import axios, { AxiosRequestConfig, Method } from "axios";

import store from "@/store";
import { tools } from "ut-utils";
import { getCurrentInfo, getLocalStorage, removeLocalStorage } from "../common";
const { commonStore, errorStore } = store;
interface ConfigMoreType {
  codeList?: number[];
}
interface ReqConfig extends AxiosRequestConfig, ConfigMoreType {
  isProgress?: any;
  responseType?: any;
  initToken?: string;
}

const service = axios.create();

let configMore: ConfigMoreType;

const { userStore } = store;
const isInvitation = window.location.pathname === "/invitation";

function request (config: ReqConfig) {
  const { codeList } = config;
  configMore = {
    codeList: codeList || [],
  };
  return service(config);
}

service.interceptors.request.use(
  (config) => {
    commonStore.setshowMessageBar(false);
    errorStore.setErrorMessage("");
    commonStore.setshowProcedureMessageBar(false);
    errorStore.setProcedureErrormessage("");
    const Name =
      window.localStorage.getItem("name") ||
      window.sessionStorage.getItem("name");

    config.timeout = config.timeout || 10 * 60 * 1000;
    config.baseURL = config.baseURL || "";
    config.method = (config.method?.toLowerCase() || "get") as Method;
    config.headers = config.headers || {};
    config.responseType = config.responseType || "json";

    commonStore.setprogressHidden(true);
    if (config.data && config.data.isProgress) {
      config.data.isProgress = true;
      commonStore.setprogressHidden(true);
      commonStore.setshowMessageBar(false);
      errorStore.setErrorMessage("");
    }
    if (userStore.token) {
      // Always prioritize the stored token in localStorage if available
      const storedToken = localStorage.getItem("token");
      const tokenToUse =
        storedToken ||
        (userStore.updateToken ? userStore.updateToken : userStore.token);
      config.headers.Authorization = `Bearer ${tokenToUse}`;
    }
    if (getCurrentInfo("region")?.toLowerCase()) {
      config.headers["X-Market"] = getCurrentInfo("region");
      config.headers["Accept-Language"] = getCurrentInfo("region")?.toLowerCase() === "zh-cn" ? "cn" : "en";
    }

    if (userStore.userName) {
      config.headers = Object.assign(
        {
          TH_Account: Name,
        },
        config.headers
      );
    }

    if (config.method === "post" || config.method === "put") {
      config.data = config.data || {};
      const contentType = (config.headers["Content-Type"] || "") as string;
      if (contentType.includes("json")) {
        config.transformRequest = [
          (data) => data && JSON.stringify(tools.filterObject(data)),
        ];
      } else if (contentType.includes("urlencoded")) {
        config.transformRequest = [
          (data) => data && tools.objToUrlParams(data),
        ];
      }
    } else if (config.method === "get") {
      config.headers["Content-Type"] = "application/json; charset=utf-8";
      config.params = { ...config.params, ...config.data };
      config.paramsSerializer = (data) => data && tools.objToUrlParams(data);
    }
    config.withCredentials = !!config.withCredentials;
    return config;
  },
  (err) => {
    Promise.reject(err);
  }
);

service.interceptors.response.use(
  (response) => {
    commonStore.setUpdateToken(false);
    if (response.headers.authorization) {
      const token = response.headers.authorization.split(" ")[1];
      commonStore.setUpdateToken(true);
      userStore.setToken(token);
      userStore.setUpdateToken(token);
      // Store the token in localStorage for persistence
      localStorage.setItem("token", token);
    } else {
      removeLocalStorage("selectToken");
      // Use the latest token from localStorage if available
      const storedToken = localStorage.getItem("token");
      if (storedToken) {
        userStore.setToken(storedToken);
        userStore.setUpdateToken(storedToken);
      } else {
        userStore.setToken(userStore.token);
      }
    }

    commonStore.setprogressHidden(false);
    if (
      response.headers["content-type"] !== "application/json; charset=utf-8"
    ) {
      return response.data;
    }

    if (response.status !== 200) {
      commonStore.setprogressHidden(false);
      if (response.status === 401) {
        if (
          !isInvitation ||
          response.headers["www-authenticate"] === "Bearer"
        ) {
          window.location.href = "/401";
        }
        localStorage.clear();
      } else if (response.status === 403) {
        window.location.href = "/403";
      } else if (response.status === 404) {
        window.location.href = "/notfound";
      }
      return response.data;
    }
    if (response.data.code === 200) {
      try {
        if (!Object.keys(response.data.data)?.includes("status")) {
          response.data.data.status =
            response.data.status || response.data.code;
        }
      } catch (e) {}
      return response.data.data;
    } else if (response.data?.code !== 200) {
      if (response.data?.code === 401) {
        if (!isInvitation) {
          window.location.href = "/401";
        }
      } else if (response.data?.code === 403) {
        if (!isInvitation) {
          window.location.href = "/403";
        }
      } else if (response.data?.code === 404) {
        if (!isInvitation) {
          window.location.href = "/notfound";
        }
      }
      commonStore.setprogressHidden(false);
      commonStore.setshowProcedureMessageBar(true);
      errorStore.setProcedureErrormessage("Error：" + response.data.message);
      return;
    }

    const res = response.data;
    try {
      if (!Object.keys(res)?.includes("status")) {
        res.status = response.status;
      }
    } catch (e) {}
    if (res.success !== true) {
      return res;
    }
    if (res.config.isProgress) {
      res.config.isProgress = false;
      commonStore.setprogressHidden(false);
    }
    if (configMore.codeList && configMore.codeList.length > 0) {
      const myCodeList = configMore.codeList.map((v) => v + "");
      if (myCodeList.includes(res.errorCode + "")) {
        return res;
      }
    }
    if (res.success === true) {
      return res;
    }
    if ([10, 11].includes(+res.errorCode)) {
      const pre =
        window.location.origin +
        window.location.pathname +
        process.env.PUBLIC_URL;
    }
    return Promise.reject(res);
  },
  (err) => {
    commonStore.setprogressHidden(false);
    if (err.response && err.response.status !== 200) {
      commonStore.setprogressHidden(false);
      if (err.response.data.diagnostic !== null) {
        commonStore.setshowMessageBar(false);
        commonStore.setshowProcedureMessageBar(true);
        errorStore.setProcedureErrormessage(
          "Error：" + err.response.data.message
        );
      } else {
        commonStore.setshowMessageBar(true);
        commonStore.setshowProcedureMessageBar(false);
        errorStore.setErrorMessage(
          "Error：" + err.response.data.message || err.response.message
        );
      }
      if (err.response.status === 401) {
        if (
          !isInvitation ||
          err.response.headers["www-authenticate"] === "Bearer"
        ) {
          window.location.href = "/401";
        }
      } else if (err.response.status === 403) {
        if (!isInvitation) {
          window.location.href = "/403";
        }
      } else if (err.response.status === 404) {
        if (!isInvitation) {
          window.location.href = "/notfound";
        }
      }
      // return err.response.data;
      return Promise.reject(err.response.data);
    } else {
      console.log(err);
      commonStore.setshowMessageBar(false);
      commonStore.setshowProcedureMessageBar(true);
      errorStore.setErrorMessage("Error：" + err.message);
    }
  }
);

export default request;
